
<multi-input :compress="compress">
  <column>
    <div class="sr-only">
      <label for="min_value">Min Value</label>
    </div>
    <input
      id="min_value"
      type="number"
      v-model.number="minValue"
      placeholder="Min Value"
      :disabled="disabled"
    />
  </column>
  <column>
    <div class="sr-only">
      <label for="max_value">Max Value</label>
    </div>
    <input
      id="max_value"
      type="number"
      v-model.number="maxValue"
      placeholder="Max Value"
      :disabled="disabled"
    />
  </column>
</multi-input>
